'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defaultState = {
  isFetching: false,
  links: {},
  order: []
};
var paginate = function paginate(types) {
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected types to be an array of three elements.');
  }
  if (!types.every(function (t) {
    return typeof t === 'string';
  })) {
    throw new Error('Expected types to be strings.');
  }
  var _types = _slicedToArray(types, 3),
    requestType = _types[0],
    successType = _types[1],
    failureType = _types[2];
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    switch (action.type) {
      case requestType:
        return _extends({}, state, {
          isFetching: true
        });
      case successType:
        var _action$response = action.response,
          links = _action$response.links,
          result = _action$response.result,
          type = _action$response.type,
          pageOrder = _action$response.pageOrder;
        var idsByPage = !!links ? _extends({}, state.idsByPage, _defineProperty({}, links.self, !!type ? result[type] : [])) : null;
        return {
          isFetching: !!action.fetchAllPages && !!links.next,
          links: links,
          idsByPage: idsByPage,
          pageOrder: pageOrder
        };
      case failureType:
        return _extends({}, state, {
          isFetching: false
        });
      default:
        return state;
    }
  };
};
exports.default = paginate;